import * as React from 'react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { roundNumber } from '@kurtosys/ksys-app-template/dist/utils/number';

const BarLabelText = styled<any, any>(
    'text',
    'barLabelText',
    'verticalBarLabel'
)`
    ${propStyles};
`;

interface VerticalBarLabelProps {
    value: number;
    fill?: string;
    viewBox?: ViewBox;
    fontSize: number | string;
    verticalAnchor?: 'start' | 'middle' | 'end';
    textAnchor?: 'start' | 'middle' | 'end' | 'inherit';
    offset: number;
    precision: number;
}

interface ViewBox {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
}

const VerticalBarLabel: React.FC<VerticalBarLabelProps> = ({
    fill = 'gray500',
    value,
    textAnchor = 'end',
    verticalAnchor = 'middle',
    fontSize = 'xs',
    viewBox,
    offset,
    precision,
}) => {
    if (precision) {
        value = roundNumber(value, precision, false) as number;
    }
    const textWidth = `${value}`.length * 6; // approximate text width for label positioning
    const x =
        value >= 0
            ? viewBox.x + viewBox.width + offset + textWidth
            : viewBox.x + viewBox.width - offset;
    const y = viewBox.y + viewBox.height / 1.5;

    return (
        <BarLabelText
            x={x}
            y={y}
            fill={fill}
            fontSize={fontSize}
            textAnchor={textAnchor}
            verticalAnchor={verticalAnchor}
        >
            {value}
        </BarLabelText>
    );
};

export default withTheme(VerticalBarLabel) as any;



// WEBPACK FOOTER //
// ./src/Components/VerticalBarLabel.tsx